<div class="filter">
  <div class="form-row">
    <dynamic-filters
      [configuration]="filterConfig"
      [defaultIds]="defaultFilters"
      (queryChange)="onQueryChange($event)"
      localStorageId="inventory/receiving"
    ></dynamic-filters>

    <div ngbDropdown class="form-group col-auto align-self-end col-sm-auto ml-auto">
      <br />
      <button
        class="lum-button lum-button--secondary"
        id="dropdownBasic1"
        ngbDropdownToggle
      >
        <span>Export RRs </span>
        <i class="fas fa-caret-down"></i>
      </button>
      <div ngbDropdownMenu aria-labelledby="action-button">
        <button ngbDropdownItem (click)="exportListToPdf()">
          <i class="fas fa-file-pdf"></i> Export to PDF
        </button>
        <button ngbDropdownItem (click)="exportListToCsv()">
          <i class="fas fa-file-csv"></i> Export to CSV
        </button>
      </div>
    </div>
  </div>
</div>

<div class="overflow-auto">
  <table class="table table-striped table-hover">
    <thead>
      <ng-template #sort let-field="field">
        <div class="lum-table__sort">
          <i
            class="fas"
            [class.fa-sort]="params.sort !== field"
            [class.fa-sort-up]="
              params.sort === field && params.sort_direction === 'asc'
            "
            [class.fa-sort-down]="
              params.sort === field && params.sort_direction === 'desc'
            "
          ></i>
        </div>
      </ng-template>

      <tr>
        <th width="130" class="link" (click)="setOrder('received_date')">
          Received Date
          <ng-container
            *ngIf="'utah-UTAH-303-receipt_id_col_filter_and_sort' | featureFlag"
            ><ng-container
              *ngTemplateOutlet="sort; context: { field: 'received_date' }"
            ></ng-container
          ></ng-container>
        </th>
        <th class="link" (click)="setOrder('id')">
          ID
          <ng-container
            *ngIf="'utah-UTAH-303-receipt_id_col_filter_and_sort' | featureFlag"
            ><ng-container
              *ngTemplateOutlet="sort; context: { field: 'id' }"
            ></ng-container
          ></ng-container>
        </th>
        <th>Tracking Number</th>
        <th>Received By</th>
        <th>SKUs/Products</th>
        <th class="text-right">Total Units</th>
        <th *ngxPermissionsOnly="['skuUnitCost.read']" class="text-right"
          >Total Cost</th
        >
        <th
          *ngFeatureFlag="
            EFeatureFlag.NEW_PURCHASE_ORDER_LIST_VIEW;
            isDisabled: false
          "
          class="text-right"
        >
          Shipping Cost
        </th>
        <th class="text-center" *ngIf="authService.loginUser.role != 2">
          &nbsp;
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="receivingReportSvc.gettingRecords">
        <td colspan="9" class="text-center">
          <br />
          <h6 [translate]="'GENERAL.GETTING_RECORDS'">
            <i class="fas fa-spinner fa-spin"></i> Getting records...
          </h6>
          <br />
        </td>
      </tr>
      <tr
        *ngIf="
          !receivingReportSvc.gettingRecords &&
          ordersRecord.data &&
          ordersRecord.data.length == 0
        "
      >
        <td colspan="9" class="text-center">
          <br />
          <h6 class="text-warning">No record found.</h6>
          <br />
        </td>
      </tr>
      <tr *ngFor="let r of ordersRecord.data; let i = index">
        <td>{{ r.received_date | date: 'mediumDate' }} <br /></td>
        <td>{{ r.id }}</td>
        <td>
          {{ r.tracking_number }}
        </td>
        <td>
          <div *ngIf="r.received_by">
            {{ r.received_by }}
            <small *ngIf="r.received_at"> [{{ r.received_at }}]</small>
          </div>
        </td>

        <td>
          <div class="rr-items">
            <span *ngFor="let item of r.receiving_report_rfq">
              <span
                *ngIf="item.purchase_order_rfq"
                [ngClass]="{
                  'kt-badge--danger':
                    item?.purchase_order_rfq?.rfq?.status === productStatus.DELETED,
                  'kt-badge--default':
                    item?.purchase_order_rfq?.rfq?.status === productStatus.ACTIVE,
                }"
                class="kt-badge kt-badge-sm kt-badge--outline kt-badge--pill"
              >
                <b> PO#{{ item.purchase_order_rfq.purchase_order_id }} </b>
                &nbsp;
                <b *ngIf="item.stock && item.stock.warehouse">
                  {{ item.stock.warehouse.location_name }}
                </b>
                <span>
                  {{ item.purchase_order_rfq.internal_sku }}
                  <small> {{ item.purchase_order_rfq.product_name }} </small>
                </span>
                <i class="d-inline-block"
                  >[&nbsp;<span
                    >x{{ item.quantity | decimalPlaces }}
                    {{
                      item?.received_uom_id
                        | uomDisplay
                          : item?.purchase_order_rfq?.rfq?.unit_of_measures
                    }}
                  </span>
                  <b>{{ item.line_total | currency: '' }}</b
                  >&nbsp;]</i
                >
              </span>
            </span>
          </div>
        </td>

        <td class="text-right">
          <b>{{ r.total_quantity | number }}</b>
        </td>
        <td *ngxPermissionsOnly="['skuUnitCost.read']" class="text-right">
          <b>{{ r.total_cost | currency: '' }}</b>
        </td>
        <td
          *ngFeatureFlag="
            EFeatureFlag.NEW_PURCHASE_ORDER_LIST_VIEW;
            isDisabled: false
          "
          class="text-right"
        >
          <b>{{ r.shipping_cost | currency: '' }}</b>
        </td>
        <td
          class="position-sticky"
          style="right: 0"
          *ngIf="authService.loginUser.role != 2"
        >
          <button
            class="bg-white"
            mat-icon-button
            [matMenuTriggerFor]="menuActions"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>

        <mat-menu #menuActions="matMenu">
          <button mat-menu-item (click)="exportRFQtoPDF(r)">
            <i class="fas fa-file-pdf"></i> Export to PDF
          </button>
          <button
            *ngIf="EFeatureFlag.LOT_TRACKING | featureFlag"
            mat-menu-item
            (click)="printLabels(r)"
          >
            <i class="fas fa-file-pdf"></i> Print Labels
          </button>
          <button mat-menu-item (click)="openDeliveryForm(r)">
            <i class="fas fa-edit text-info"></i> Edit
          </button>
          <button mat-menu-item (click)="deleteReceivingReport(r)">
            <i class="fas fa-trash text-danger"></i> Delete
          </button>
        </mat-menu>
      </tr>
    </tbody>
  </table>
</div>

<mat-paginator
  [length]="ordersRecord?.meta?.total"
  [pageSize]="ordersRecord?.meta?.per_page"
  [pageSizeOptions]="pageSizeOptions"
  (page)="handlePagination($event)"
  class="lum-paging lum-paging--dodge-back-to-top lum-paging--sticky"
>
</mat-paginator>
